import { useCallback } from 'react';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import styles from './files-list.module.css';
import PropTypes from 'prop-types';

const FilesListItem = ({ name, id, onClear, uploadComplete }) => {
    const handleClear = useCallback(() => {
        onClear(id);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <li className={styles.files_list_item}>
            <span className={styles.files_list_item_name}>{name}</span>
            {!uploadComplete ? (
                <span
                    className={styles.files_list_item_clear}
                    role="button"
                    aria-label="remove file"
                    onClick={handleClear}
                    onKeyPress={handleClear}
                    tabIndex={0}
                >
                    <ClearIcon />
                </span>
            ) : (
                <span role="img" className={styles.file_list_item_check}>
                    <CheckIcon />
                </span>
            )}
        </li>
    );
};

FilesListItem.propTypes = {
    name: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    onClear: PropTypes.func.isRequired,
    uploadComplete: PropTypes.bool.isRequired
};

const FilesList = ({ files, onClear, uploadComplete }) => {
    return (
        <ul className={styles.files_list}>
            {files.map(({ file, id }) => (
                <FilesListItem name={file.name} key={id} id={id} onClear={onClear} uploadComplete={uploadComplete} />
            ))}
        </ul>
    );
};

FilesList.propTypes = {
    files: PropTypes.arrayOf(
        PropTypes.shape({
            file: PropTypes.object,
            id: PropTypes.string
        })
    ).isRequired,
    onClear: PropTypes.func.isRequired,
    uploadComplete: PropTypes.bool.isRequired
};

export { FilesList };
